export default __webpack_public_path__ + "92bff471b9ab6ec18ee90b33d8895732.svg";